module.exports = __webpack_public_path__ + "fonts/Roboto-Bold.ttf?e07df86cef2e721115583d61d1fb68a6";